import { NotificationPreferencesScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <NotificationPreferencesScreen />;
}
